import HomeHeroSearch from './HomeHeroSearch';

export default function HomeHeroStrip(props) {
  return <HomeHeroSearch {...props} />;
}
